import { Link } from "react-router-dom";
import { Heart } from "lucide-react";
import { mediaUrl } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function ProductCard({ product }) {
  const { user, wishlist, toggleWishlist } = useAuth();
  const price = product.sale_price || product.price;
  const onSale = product.sale_price && product.sale_price < product.price;
  const inWish = wishlist?.includes(product.id);
  const img1 = mediaUrl(product.images?.[0]);
  const img2 = mediaUrl(product.images?.[1]) || img1;

  const wish = async (e) => {
    e.preventDefault();
    if (!user) return toast.error("Log in om te bewaren op je verlanglijst");
    const added = await toggleWishlist(product.id);
    toast.success(added ? "Toegevoegd aan verlanglijst" : "Verwijderd van verlanglijst");
  };

  return (
    <Link to={`/product/${product.slug}`} className="group block" data-testid={`product-card-${product.slug}`}>
      <div className="relative aspect-[3/4] bg-[#E8E1D8] overflow-hidden">
        <img src={img1} alt={product.alt_text || product.name} loading="lazy" className="absolute inset-0 w-full h-full object-cover transition-opacity duration-500 group-hover:opacity-0" />
        <img src={img2} alt={product.name} loading="lazy" className="absolute inset-0 w-full h-full object-cover opacity-0 transition-all duration-700 group-hover:opacity-100 group-hover:scale-[1.03]" />
        {product.badge && (
          <span className="absolute top-3 left-3 bg-[#F7F5F1] text-[#1D1D1B] label-x px-2.5 py-1" data-testid={`product-badge-${product.slug}`}>{product.badge}</span>
        )}
        <button onClick={wish} aria-label="Wishlist" className="absolute top-3 right-3 opacity-0 group-hover:opacity-100 transition-opacity" data-testid={`product-wish-${product.slug}`}>
          <Heart size={18} fill={inWish ? "#1D1D1B" : "none"} />
        </button>
      </div>
      <div className="mt-3">
        <p className="text-xs md:text-sm uppercase tracking-[0.08em] font-medium">{product.name}</p>
        <div className="flex items-center gap-2 mt-1">
          <span className="text-sm md:text-base font-semibold tracking-tight">€{price.toFixed(2)}</span>
          {onSale && <span className="text-xs text-[#77736D] line-through">€{product.price.toFixed(2)}</span>}
        </div>
      </div>
    </Link>
  );
}
